import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import AppImage from "../../components/AppImage";
import IntroSection from "../../components/IntroSection";
import CardData from "../../components/CardData";

// import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";

import Review from 'components/review'; // Assuming Review is in the components folder
import { SkinPass } from "../../components/SkinPass";
import { MiniTable } from "../../components/MiniTable";
import SEO from '../../components/SEO';

const ProductsPage = () => {
 

  return (
    <div className="min-h-screen flex flex-col"  style={{ backgroundColor: "#7A6E62" }}>
      <SEO 
      title = 'Cosmelytix - Personalized Anti-Age Skincare & Beauty Recommendations'
      description = "Discover expert anti-age skincare and beauty product recommendations based on smart ingredient analysis. Find your perfect products with Cosmelytix."
      url = 'https://cosmelytix.com'
      />

      <Header />
      
      <main className="flex-grow py-6 px-2 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">


      

<IntroSection />




      <Review />
      <br/>
      <SkinPass />
      <br/>
      <br/>
      <MiniTable />
      <CardData />
   

        
        <div className="mt-8 bg-surface border border-border rounded-lg p-6">
          <h2 className="text-xl font-semibold text-text-primary mb-4">
            Need more information?
          </h2>
          <p className="text-text-secondary mb-4">
            Check out our API documentation to learn how to integrate our products into your applications.
          </p>
          {/* <Link 
            to="/api-documentation-page"
            className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            <Icon name="FileText" className="mr-2" size={16} />
            View API Documentation
          </Link> */}
<a href="/api-documentation-page">
  <button className="w-full py-3 text-center text-white border-2 border-white rounded-full text-lg font-normal mt-6">
    View API Documentation
  </button>
</a>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ProductsPage;